__turbopack_context__.v({
  "chevronLeft": "SubSectionWrapper-module__lqU8qq__chevronLeft",
  "root": "SubSectionWrapper-module__lqU8qq__root",
  "stackedPreferences": "SubSectionWrapper-module__lqU8qq__stackedPreferences",
  "title": "SubSectionWrapper-module__lqU8qq__title",
});
